import { z } from "zod";

export const surgicalHistoryFormSchema = z.object({
  performedDate: z
    .date()
    .min(
      new Date("1900-01-01"),
      "Performed date must be greater than or equal to 1900-01-01",
    ),
  procedureCode: z.string().min(1, "Procedure code is required"),
  procedureCodeDisplay: z.string().min(1, "Procedure display is required"),
  procedureCodeSystem: z.string().min(1, "Procedure system is required"),
});
